<template>
    <div class="infoWrap">
        <!-- 第一块 -->
        <div class="title">
            基本信息
            <!-- <img src="../../../assets/common_icon_xiugai.png" alt="" class="icon"> -->
            <!-- <div class="rightBtn">
                <button class="cg-btn ">新增</button>
            </div> -->
        </div>
        <div class="content">
            <div class="oneItem">
                <span class="mylabel">用户名称/企业名称:</span>
                <span class="text">{{userInfo.user_organization_name || userInfo.user_individual_name}}</span>
            </div>
            <div class="oneItem">
                <span class="mylabel">注册手机号:</span>
                <span class="text">{{account}}</span>

            </div>
            <div class="oneItem">
                <span class="mylabel">联系人姓名:</span>
                <span class="text">{{userInfo.user_contact_person}}</span>
            </div>
            <div class="oneItem">
                <span class="mylabel">联系人手机号:</span>
                <span class="text">{{userInfo.user_contact_cellphone}}</span>
            </div>
        </div>
        <!-- 第2块 -->
        <!-- <div class="title">
            品牌设置
            <div class="rightBtn">
                <button class="cg-btn" @click="brandDialogVisible = true">新增</button>
            </div>
        </div>
        <div class="content">
            <span v-if="brandList.length == 0">暂无品牌</span>
            <div class="brand-wrap" v-else>
                <span class="mylabel" v-for="(item, index) in brandList" :key="index">
                    {{index > 0 ? '，' : ''}}
                    {{item.item_display_name}}
                </span>
            </div>
        </div> -->
        <!-- 第3块 -->
        <user-address />
        
        <el-dialog
            title="新增品牌"
            :visible.sync="brandDialogVisible"
            width="500px"
            :close-on-click-modal="false">
            <el-form
                :model="brandForm"
                :rules="brandRules"
                ref="brandForm"
                label-width="120px"
            >
                <el-form-item label="品牌名称：" prop="brand">
                    <el-input size="small" style="width: 260px" v-model.trim="brandForm.brand" placeholder="请输入品牌名称"></el-input>
                </el-form-item>
                <el-form-item label="">
                    <button class="cg-btn" type="button" @click="brandDialogVisible = false">取消</button>
                    <button class="cg-btn red mgl-16" type="button" @click="submitBrand">确定</button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { userInfo } from '../../../api/public'
import { brandListByUser, addBrand } from '../../../api/supplier'
import { mapGetters } from 'vuex'
import userAddress from './user-address'
export default {
    components: {
        userAddress
    },
    data() {
        return {
            // 个人信息
            userInfo: {
                user_id: "",
                user_contact_cellphone: "",
                user_contact_person: "",
                user_individual_name: "",
                user_organization_name: '',
                user_initial_type: '',
                user_last_type: ""
            },
            
            // 品牌设置
            brandDialogVisible: false,
            brandList: [],
            brandForm: {
                brand: ''
            },
            brandRules: {
                brand: [
                    { required: true, message: "请输入商品品牌", trigger: "change" }
                ],
            }
        }
    },
    computed: {
        ...mapGetters(['userId', 'account'])
    },
    created() {
        this.getUserInfo()
        this.brandListByUser()
        // this.requestUserAddressList()
    },
    methods: {
        // 获取个人信息
        getUserInfo() {
            userInfo({
                userId: this.userId
            }).then(res => {
                console.log(res)
                if (res.errorCode == 200) {
                    this.userInfo = res.data
                } else {
                    this.$message.error(res.errorMsg || '获取个人信息失败')
                }
            }).catch(err => {
                console.log(err)
            })
        },
        // 获取品牌列表
        brandListByUser() {
            brandListByUser({
                userId: this.userId
            }).then(res => {
                console.log(res)
                if (res.errorCode == 200) {
                    this.brandList = res.data
                } else {
                    // this.$message.error(res.errorMsg || '获取品牌信息失败')
                }
            }).catch(error => {
                console.log(error)
            })
        },
        // 新增品牌
        submitBrand() {
            this.$refs['brandForm'].validate((valid) => {
                if (valid) {
                    addBrand({
                        userId: this.userId,
                        brand: this.brandForm.brand
                    }).then(res => {
                        if (res.errorCode == 200) {
                            this.brandDialogVisible = false
                            this.brandForm.brand = ''
                            this.$message.success('新增品牌成功')
                            this.brandListByUser()
                        } else {
                            this.$message.error(res.errorMsg || '新增品牌失败')
                        }
                    }).catch(error => {
                        console.log(error)
                    })
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.infoWrap{
    color:#000; background: #fff;padding:24px;
    .title{
        height: 64px;line-height: 64px;font-size: 16px;opacity:0.85;font-weight: bold; position: relative;
        .icon{width: 15px;height: 15px; margin-left:14px; vertical-align: middle;}
        .rightBtn{position: absolute;top:0;right:24px;
            button{width: 44px;height: 24px;padding:0;border-radius: 2px;}
        }
    }
    .content{
        border-bottom:1px solid #eee;padding-bottom: 26px;
        .brand-wrap {
            width: 80%;
            .mylabel {
                margin-bottom: 8px;
            }
        }
        .oneItem{
            display: inline-block;width: 33%;margin-bottom: 16px;
            .mylabel{opacity:0.85;margin-right: 6px;}
            .text{opacity:0.65;}
        }
    }
    .content:last-child{border-bottom: 0;}
}
</style>